
import {formatMoney} from '@shopify/theme-currency';
import firePriceChange from '../../dom/priceChangeEvt';

/**
 * 
 * @param {Array} priceEls - elements that show product price 
 * @param {Array} compareAtPriceEls elements that show compare at price
 * @returns {Function(price{Number}, compareAtPrice{Number})} - function that takes the price and (optionally) a compare-at-price returns an (impure) function that does the update
 */
const updatePrice = (priceEls, compareAtPriceEls, format) => ((variant) => {
  if (!variant) {
    return false
  }
  const newPrice = formatMoney(variant.price, format);
  
  [...priceEls].forEach(priceEl => {
    if (priceEl.innerHTML !== newPrice) {
      priceEl.innerHTML = newPrice
      firePriceChange(priceEl)
    }
  }
  );
  const newCompareAtPrice = variant.compare_at_price && variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price, format) : '';
  [...compareAtPriceEls].forEach(compareAtPriceEl => {
    if (compareAtPriceEl.innerHTML !== newCompareAtPrice) {
      compareAtPriceEl.innerHTML = newCompareAtPrice
      firePriceChange(compareAtPriceEl)
    }
  });

})

export default updatePrice;